import EditTracking from './edit_tracking'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    initialValues: {
      shareProgress: campaign.share_progress,
      shareContributorsDetails: campaign.share_contributors,
      shareContributionsAmount: campaign.share_contributions,
    },
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, {
          share_progress: formValues.shareProgress,
          share_contributors: formValues.shareContributorsDetails,
          share_contributions: formValues.shareContributionsAmount,
        })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_tracking',
    fields: [
      'shareProgress',
      'shareContributorsDetails',
      'shareContributionsAmount',
    ],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditTracking)
